(function () {
  function getDatasetValue(node, base, lang) {
    const key = base + (lang === 'de' ? 'De' : 'En');
    return node && node.dataset ? node.dataset[key] || '' : '';
  }

  function setLanguage(lang) {
    const safeLang = lang === 'de' ? 'de' : 'en';
    document.documentElement.lang = safeLang;

    document.querySelectorAll('[data-wc-lang]').forEach(function (node) {
      node.classList.toggle('wc-lang-hidden', node.getAttribute('data-wc-lang') !== safeLang);
    });

    document.querySelectorAll('[data-placeholder-en]').forEach(function (node) {
      const value = node.getAttribute('data-placeholder-' + safeLang);
      if (value !== null) {
        node.setAttribute('placeholder', value);
      }
    });

    document.querySelectorAll('[data-label-en]').forEach(function (node) {
      const value = node.getAttribute('data-label-' + safeLang);
      if (value !== null) {
        node.textContent = value;
      }
    });

    document.querySelectorAll('[data-submit-en]').forEach(function (node) {
      if (node.dataset.wcLoading === 'true') {
        return;
      }

      const value = getDatasetValue(node, 'submit', safeLang);
      if (value) {
        node.textContent = value;
      }
    });

    document.querySelectorAll('[data-wc-set-lang]').forEach(function (button) {
      button.classList.toggle('is-active', button.getAttribute('data-wc-set-lang') === safeLang);
    });

    document.querySelectorAll('[data-default-lang]').forEach(function (node) {
      node.dataset.currentLang = safeLang;
    });
  }

  function initObserver() {
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('.wc-fade-in').forEach(function (node) {
        node.classList.add('is-visible');
      });
      return;
    }

    const observer = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) {
          return;
        }

        entry.target.classList.add('is-visible');
        obs.unobserve(entry.target);
      });
    }, { threshold: 0.1 });

    document.querySelectorAll('.wc-fade-in').forEach(function (node) {
      if (node.dataset.wcObserved === 'true') {
        return;
      }

      node.dataset.wcObserved = 'true';
      observer.observe(node);
    });
  }

  function initAccordions() {
    document.querySelectorAll('[data-wc-accordion]').forEach(function (card) {
      if (card.dataset.wcAccordionBound === 'true') {
        return;
      }

      const toggle = card.querySelector('[data-wc-accordion-toggle]');
      const panel = card.querySelector('[data-wc-accordion-panel]');

      if (!toggle || !panel) {
        return;
      }

      card.dataset.wcAccordionBound = 'true';

      const setOpen = function (isOpen) {
        card.classList.toggle('is-open', isOpen);
        toggle.setAttribute('aria-expanded', String(isOpen));
        panel.hidden = !isOpen;
      };

      setOpen(toggle.getAttribute('aria-expanded') === 'true');

      toggle.addEventListener('click', function () {
        setOpen(toggle.getAttribute('aria-expanded') !== 'true');
      });
    });
  }

  function initWorldCupPage() {
    const page = document.querySelector('[data-world-cup-page]');
    if (!page) {
      return;
    }

    const defaultLang = page.getAttribute('data-default-lang') === 'de' ? 'de' : 'en';
    if (!page.dataset.currentLang) {
      page.dataset.currentLang = defaultLang;
    }

    document.querySelectorAll('[data-wc-set-lang]').forEach(function (button) {
      if (button.dataset.wcBound === 'true') {
        return;
      }

      button.dataset.wcBound = 'true';
      button.addEventListener('click', function () {
        const nextLang = button.getAttribute('data-wc-set-lang');
        page.dataset.currentLang = nextLang;
        setLanguage(nextLang);
      });
    });

    const navbar = document.getElementById('wc-navbar');
    if (navbar && navbar.dataset.wcBound !== 'true') {
      navbar.dataset.wcBound = 'true';
      const updateNavbar = function () {
        navbar.classList.toggle('is-scrolled', window.scrollY > 60);
      };

      updateNavbar();
      window.addEventListener('scroll', updateNavbar, { passive: true });
    }

    const mobileToggle = document.getElementById('wc-mobile-toggle');
    const mobileMenu = document.getElementById('wc-mobile-menu');
    if (mobileToggle && mobileMenu && mobileToggle.dataset.wcBound !== 'true') {
      mobileToggle.dataset.wcBound = 'true';
      const closeMobile = function () {
        mobileMenu.classList.remove('is-open');
        mobileToggle.classList.remove('is-open');
        mobileToggle.setAttribute('aria-expanded', 'false');
      };

      mobileToggle.addEventListener('click', function () {
        const isOpen = mobileMenu.classList.toggle('is-open');
        mobileToggle.classList.toggle('is-open', isOpen);
        mobileToggle.setAttribute('aria-expanded', String(isOpen));
      });

      document.querySelectorAll('[data-wc-close-mobile]').forEach(function (node) {
        if (node.dataset.wcBound === 'true') {
          return;
        }

        node.dataset.wcBound = 'true';
        node.addEventListener('click', closeMobile);
      });
    }

    initAccordions();
    initObserver();

    const shuttleYes = document.getElementById('wc-shuttle-yes');
    const shuttleNo = document.getElementById('wc-shuttle-no');
    const shuttleWrap = document.getElementById('wc-shuttle-wrap');
    const shuttleCount = document.getElementById('wc-shuttle-count');

    if (shuttleYes && shuttleNo && shuttleWrap && shuttleCount && shuttleYes.dataset.wcBound !== 'true') {
      shuttleYes.dataset.wcBound = 'true';
      shuttleNo.dataset.wcBound = 'true';
      const updateShuttle = function () {
        const show = shuttleYes.checked;
        shuttleWrap.classList.toggle('is-hidden', !show);
        shuttleCount.required = show;

        if (!show) {
          shuttleCount.value = '';
        }
      };

      shuttleYes.addEventListener('change', updateShuttle);
      shuttleNo.addEventListener('change', updateShuttle);
      updateShuttle();
    }

    const form = document.getElementById('wc-registration-form');
    const status = document.getElementById('wc-form-status');
    const submit = document.getElementById('wc-submit');

    if (form && status && submit && form.dataset.wcBound !== 'true') {
      form.dataset.wcBound = 'true';
      const showStatus = function (type, message) {
        status.className = 'wc-status is-visible';

        if (type) {
          status.classList.add('is-' + type);
        }

        status.textContent = message;
      };

      form.addEventListener('submit', async function (event) {
        event.preventDefault();

        if (!form.checkValidity()) {
          form.reportValidity();
          return;
        }

        const lang = page.dataset.currentLang || defaultLang;
        const sendingText = getDatasetValue(form, 'statusSending', lang);
        const successText = getDatasetValue(form, 'statusSuccess', lang);
        const errorText = getDatasetValue(form, 'statusError', lang);

        submit.disabled = true;
        submit.dataset.wcLoading = 'true';
        submit.textContent = sendingText;
        showStatus('pending', sendingText);

        try {
          const formData = new FormData(form);
          const payload = Object.fromEntries(formData.entries());

          payload.disclaimer_liability = document.getElementById('wc-disclaimer-liability').checked ? 'Accepted' : 'Not accepted';
          payload.consent_marketing = document.getElementById('wc-consent-marketing').checked ? 'Accepted' : 'Not accepted';
          payload.consent_data = document.getElementById('wc-consent-data').checked ? 'Accepted' : 'Not accepted';

          const response = await fetch(form.getAttribute('action'), {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify(payload)
          });

          const json = await response.json();

          if (!response.ok || !json.success) {
            throw new Error(json.message || 'Form submission failed');
          }

          form.reset();

          if (shuttleWrap && shuttleCount) {
            shuttleWrap.classList.add('is-hidden');
            shuttleCount.required = false;
          }

          showStatus('success', successText);
          status.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        } catch (error) {
          showStatus('error', errorText);
        } finally {
          submit.disabled = false;
          delete submit.dataset.wcLoading;
          submit.textContent = getDatasetValue(submit, 'submit', page.dataset.currentLang || defaultLang);
        }
      });
    }

    setLanguage(page.dataset.currentLang || defaultLang);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWorldCupPage);
  } else {
    initWorldCupPage();
  }

  document.addEventListener('shopify:section:load', initWorldCupPage);
})();
